import React from "react";

const RealVshape = (props) => {
  return (
    <div style={{ width: props.size, height: props.size }}>
      <div
        style={{
          width: props.size,
          height: props.size,
          backgroundSize: "cover",

          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // backgroundColor: "rgba(255, 0, 0, 0.5)",
          backgroundImage: "url('/shape_v.png')",
          backgroundColor: props.color,
          // border: "1px solid grey",
          boxSizing: "border-box",
        }}
      ></div>
    </div>
  );
};

export default RealVshape;
